import React, { useState } from 'react';

const Ecosystem = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const ecosystemItems = [
    {
      id: 'apps',
      title: 'Apps & Protocols',
      description: 'Payments, AMMs, dark pools, mixers, and more',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      status: 'active',
      projects: [
        {
          id: 'qash',
          name: 'Qash',
          description: 'Programmable Private Payments',
          tags: ['Payments', 'Privacy'],
          url: 'https://www.qash.finance/',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none" width="32" height="32">
              <path d="M22.55 19.8068C23.5678 22.1394 26.0636 22.6779 27.07 22.6521C27.2104 22.6485 27.3398 22.7571 27.3398 22.8976V28.0348C27.3398 28.1479 27.2549 28.2434 27.1419 28.2509C25.114 28.3853 21.1046 27.4321 19.7235 25.3775C17.9597 22.7534 16.3394 21.8409 15.3731 21.6636C15.2598 21.6428 15.1718 21.5477 15.1718 21.4325V15.8295C15.1718 15.7213 15.2494 15.6283 15.3568 15.6156C17.5095 15.3613 21.2244 16.7691 22.55 19.8068Z" fill="#06FFB4" />
              <path d="M14.9737 3.60462C15.0831 3.60285 15.1719 3.69174 15.1719 3.80116V8.04806C15.1719 8.15748 15.0832 8.2459 14.9738 8.24879C13.0499 8.29941 11.2155 9.08577 9.85106 10.4502C8.43988 11.8614 7.64707 13.7753 7.64707 15.7711C7.64707 17.7668 8.43988 19.6807 9.85106 21.0919C11.2155 22.4563 13.0499 23.2427 14.9738 23.2933C15.0832 23.2962 15.1719 23.3846 15.1719 23.4941V27.7409C15.1719 27.8503 15.0831 27.9392 14.9737 27.9374C11.8183 27.8861 8.80301 26.6103 6.56783 24.3751C4.28589 22.0932 3.00391 18.9982 3.00391 15.7711C3.00391 12.5439 4.28588 9.4489 6.56783 7.16695C8.80301 4.93176 11.8183 3.65597 14.9737 3.60462ZM26.086 12.7141C26.086 12.8367 25.9866 12.9361 25.864 12.9361H21.6414C21.5188 12.9361 21.4195 12.8367 21.4195 12.7141V8.26954H25.864C25.9866 8.26954 26.086 8.36891 26.086 8.49149V12.7141ZM21.4195 8.26954H16.9749C16.8523 8.26954 16.753 8.17018 16.753 8.0476V3.82498C16.753 3.7024 16.8523 3.60303 16.9749 3.60303H21.1975C21.3201 3.60303 21.4195 3.7024 21.4195 3.82498V8.26954Z" fill="#066EFF" />
            </svg>
          )
        },
        {
          id: 'zoro',
          name: 'Zoro',
          description: 'Public/Private Oracle-informed AMM',
          tags: ['DeFi AMM', 'Privacy'],
          url: 'https://zoroswap.com/',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1474" fill="none" width="32" height="32">
              <path fill="currentColor" d="M659.12 682.49c168.76 15.37 326.99 25.43 588.1-1.92 76.96-8.07 666.91-60.15 672.76-168.1 3.62-66.79-230.42-93.8-349.13-110.82-8.5-1.21-143.09-17.5-143.09-17.5s-.85-20.35-1.2-28.93l-8.27-204.72c0 0-1.16-45.69-4.71-80.22-2.35-22.89-35.21-27.35-51.52-33.08-9.38-3.3-96.49-23.62-240.02-31.99-110.92-5.42-149-8.56-273.97.74C723.1 15.2 620.37 38.84 584.88 47.63c-30.8 7.63-49.95 12.91-67.65 21.3-21.37 10.14-34.64 32.07-34.26 55.73l4.27 263.93c.08 5.16-.19 20.55-.31 27.05-.03 1.72-1.26 3.17-2.93 3.48-5.69 1.05-18.53 3.4-26.82 4.52C351.8 437.99 9.71 490.09.17 562.11c-9.72 73.33 372.69 112.24 479.16 121.65 5.43.48 14.77 1.88 20.2 2.73 2.62.41 4.74 2.28 5.5 4.82 1.75 5.83 4.79 16.34 5.64 21.88l62.54 409.76c0 0 .79 3.53 1.28 4.42.49.89 1.32 2.57 2.43 3.99 1.05 1.35 281.33 295.63 282.68 296.98 12.42 12.42 3.29 2.54 14.04 14.77 0 0 15.29 15.11 34.37 22.81 12.86 5.19 93.43 19.07 151.18-8.57 14-6.7 35.13-20.87 36.74-21.95.71-.48 1.92-1.39 3.06-2.28 1.8-1.41 3.45-2.99 4.94-4.72l264.21-307.04c3.22-3.74 4.46-8.39 4.89-13.32 3.21-36.39 15.97-195.15 29.44-352.79.64-7.45 1.77-26.78 2.35-36.69.18-3.08-2.5-5.58-5.55-5.15-10.18 1.45-6.18 9.89-354.81 9.89C795.88 723.28 644.25 681.12 659.12 682.49zM1117.76 515.62c100.83-11.61 102.27-20.01 105.19-20.59-.4-13.14-14.47-352.23-14.47-352.23s40.1-7.44 58.81-11.61c17.2-3.84 62.92-14.47 62.92-14.47s13.38 272.44 18.96 353.91c125.81 25.21 467.28 49.73 467.28 49.73 1.02.12-16.9 9.68-17.89 10.04-16.25 5.98-47.71 17.25-60.24 20.68-39.63 10.86-49.16 14.04-65.65 17.48-31.23 6.52-33.6 6.96-62.82 13.07-32.24 6.74-105.88 20.51-153.13 24.78-2.35.22-171.62-67.48-184.44-72.1-11.04-3.97-32.67-8.83-32.67-8.83s-50.87 6.63-72.31 9.28c-45.35 5.6-91.09 6.29-136.74 7.36-39.91.93-121.95-2.17-121.95-2.17S918.57 538.57 1117.76 515.62zM938.26 1108.03c.59-2.68 3.11-4.45 5.83-4.12 10.74 1.3 47.48 9.32 47.48 9.32 3.58.63 7.22-.61 9.47-3.45 7.14-8.98 92.11-78.63 117.76-99.59 4.68-3.84 10.07-6.66 15.87-8.39 21.66-6.47 63.18-24.32 97.28-39.91 36.19-16.54 77.53-38.27 91.51-45.71 1.77-.94 3.78.75 3.15 2.66-30.52 91.41-131.29 308.13-155.29 357.44-3.44 7.07-7.59 13.77-12.43 19.97-15.95 20.4-49.92 67.23-97.65 79.5-25.56 6.58-58.21 12.67-83.2 4.05-11.7-4.03-23.34-11.53-27.68-24.55-4.89-14.63 2.76-30.8 13.07-34.98 37.29-15.09 104.69-40.18 117.65-55.9 2.16-2.62-.7-6.65-3.59-7.9-9.68-4.18-60.32-4.93-85.63-3.03-15.44 1.16-43.1 6.48-48.23-11.9-5.54-19.84 1.47-30.76 16.94-33.82 26.67-5.27 62.58-12.22 97.39-24.66 54.06-19.33 96.68-43.16 114.1-48.23 10.07.98 10.97 7.17 14.93 8.39.57.18 10.62-11.51 11.3-15.38 1.57-9.08-4.97-24.62-7.66-34.09-2.06-7.3-7.62-20.29-15.48-20.38-3.67-.04-18.62 1.99-27.35 4.46-4.29 1.2-7.7 6.93-5.27 10.67.55.85 2.36 4.3 4.63 8.26 1.79 3.14 1.28 7.67-1.84 9.46-19.48 11.12-18.85 12.13-72.59 33.19-58.51 22.93-102.95 25.88-131.44 26.48-4.16.08-7.62-3.18-7.71-7.34C933.22 1142.54 936.16 1117.56 938.26 1108.03z" />
            </svg>
          )
        },
        {
          id: 'lumina',
          name: 'Lumina Engine',
          description: 'Institutional-grade Programmable Dark Pool',
          tags: ['Institutional', 'DeFi AMM'],
          url: 'https://www.luminaengine.ai/',
          logo: (
            <svg width="32" height="32" viewBox="0 0 2982 2982" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2606 1491C2606 875.203 2106.8 376 1491 376C875.203 376 376 875.203 376 1491C376 2106.8 875.203 2606 1491 2606V2687C830.467 2687 295 2151.53 295 1491C295 830.467 830.467 295 1491 295C2151.53 295 2687 830.467 2687 1491C2687 2151.53 2151.53 2687 1491 2687V2606C2106.8 2606 2606 2106.8 2606 1491Z" fill="url(#paint0_linear_196_2270)" />
              <defs>
                <linearGradient id="paint0_linear_196_2270" x1="419.347" y1="985.873" x2="2472.36" y2="2063.2" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#E7BA2C" />
                  <stop offset="1" stopColor="#CD8000" />
                </linearGradient>
              </defs>
            </svg>
          )
        },
        {
          id: 'dome',
          name: 'Dome',
          description: 'Compliant Onchain Mixer',
          tags: ['Compliance', 'Privacy'],
          url: 'https://github.com/arcane-finance-defi/miden-bridge-mono',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 66" fill="none" width="32" height="32">
              <path d="M65.2358 9.40243C62.4202 6.63457 58.8888 4.5348 54.737 3.05543C50.5374 1.57605 45.7653 0.8125 40.3727 0.8125H0V64.6643H40.3727C45.7653 64.6643 50.5852 63.9008 54.737 62.4214C58.9365 60.942 62.4202 58.8423 65.2358 56.0744C68.1468 53.3065 70.2943 49.966 71.7737 46.0051C73.2531 42.0919 73.9689 37.6538 73.9689 32.8339V32.7384C73.9689 27.8231 73.2531 23.3849 71.7737 19.4717C70.2943 15.5586 68.1468 12.1703 65.2358 9.40243ZM56.9322 32.8339C56.9322 37.7969 55.5482 41.7101 52.7804 44.5257C50.0602 47.2936 45.9084 48.6775 40.325 48.6775H17.2753V22.6691C17.2753 21.667 16.6072 20.7602 15.6528 20.4262L9.25804 18.231C8.44677 17.9446 8.63765 16.7516 9.49665 16.7516H17.2276H40.2772C45.8607 16.7516 50.0125 18.1833 52.7326 20.9988C55.5005 23.8144 56.8845 27.7276 56.8845 32.6907V32.8339H56.9322Z" fill="black" />
            </svg>
          )
        }
      ],
      buildersWanted: false
    },
    {
      id: 'tools',
      title: 'Developer Tools',
      description: 'SDKs, libraries, and development frameworks',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      status: 'active',
      projects: [
        {
          id: 'walnut',
          name: 'Walnut',
          description: 'Miden Playground - Interactive development environment',
          tags: ['Playground', 'Infra'],
          url: 'https://playground.miden.xyz/',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 973" fill="none" width="32" height="32">
              <path fill="currentColor" d="M573.3 647.1c29.3 21 61.1 38.7 94.9 52.4 6.3 2.6 13.4 1.7 18.9-2.3 38.6-28.4 71.6-64 97.2-104.8 6.9-11 .7-25.6-11.9-28.6-42.2-10-80.9-29-114-54.8-9.9-7.7-24.3-4.3-29.4 7.1-16.6 36.9-36.7 71.9-60 104.4C563 629 564.8 641 573.3 647.1z" />
              <path fill="currentColor" d="M842.1 390.6v.6c0 3.2 0 6.4-.1 9.6 0 1.6-.1 3.3-.2 4.9 0 .8 0 1.7-.1 2.5-.1 1.9-.2 3.9-.3 5.8 0 .1 0 .2 0 .3l0 0c-.9 11.1-11 19.1-22.1 17.6-71.2-10.1-127.5-66.6-137.2-138-1.6-11.6 7.4-21.9 19-21.9h107.8c8.6 0 15.8 5.6 18.3 13.3.2.7.4 1.3.6 2C837.1 320.1 842 354.8 842.1 390.6z" />
              <path fill="currentColor" d="M284 492.5c-37.1 34.2-82.8 59.2-133.6 71.3-12.7 3-18.8 17.6-11.9 28.6 25.5 40.8 58.6 76.4 97.2 104.8 5.5 4 12.6 4.9 18.9 2.3 39.8-16.2 76.9-37.8 110.2-63.9 37.2-29.1 69.7-63.8 96.5-102.8 47.5-69.1 76.6-151.8 80.3-241.5.5-10.8-8.3-19.8-19.2-19.8H399.2c-10.1 0-18.5 7.8-19.1 17.9C375.4 369.9 339.3 441.5 284 492.5z" />
              <path fill="currentColor" d="M240.6 293.9c-9.7 71.3-65.9 127.9-137.2 138-9.8 1.4-18.9-4.7-21.4-13.8-.7-8.9-1-18-1-27.1 0-35.9 5-70.7 14.3-103.7.2-.7.3-1.4.6-2.1 2.5-7.7 9.7-13.2 18.2-13.2h107.4C233.3 272 242.2 282.3 240.6 293.9z" />
            </svg>
          )
        }
      ],
      buildersWanted: false
    },
    {
      id: 'wallets',
      title: 'Wallets',
      description: 'Secure wallet solutions for Miden assets',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 12h5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="18" cy="12" r="1" fill="white"/>
        </svg>
      ),
      status: 'active',
      projects: [
        {
          id: 'miden-wallet',
          name: 'Miden Browser Wallet',
          description: 'In-browser Wallet for Easy Payments',
          tags: ['Wallet', 'Payments'],
          url: 'https://midenbrowserwallet.com/',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="none" width="32" height="32">
              <polygon fill="none" points="35.2,47.09792284866469 31.200000000000003,52.79525222551929 30.400000000000002,58.87240356083086 30.400000000000002,209.66172106824928 31.200000000000003,215.35905044510386 34.0,219.91691394658756 36.800000000000004,222.1958456973294 42.400000000000006,224.09495548961425 204.8,224.09495548961425 211.60000000000002,221.43620178041544 214.4,218.7774480712166 216.8,212.70029673590506 216.8,55.07418397626113 214.4,49.37685459940653 210.4,45.95845697329377 204.8,44.439169139465875 43.2,44.439169139465875" stroke="#FF5500" strokeLinejoin="round" strokeWidth="20" />
              <polygon fill="#FF5500" points="66.400,88.878 66.400,180.036 67.200,180.795 76.000,180.795 78.800,178.896 123.600,135.596 169.600,180.036 171.200,180.795 179.600,180.795 180.800,179.656 180.800,88.878 179.600,87.739 162.800,87.739 161.600,88.878 161.200,146.231 124.800,111.288 121.200,112.047 86.400,146.231 86.000,89.258 84.400,87.739 67.600,87.739" stroke="none" />
            </svg>
          )
        }
      ],
      buildersWanted: false
    },
    {
      id: 'bridges',
      title: 'Bridges',
      description: 'Cross-chain connectivity solutions',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="9" cy="7" r="4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      status: 'coming-soon',
      projects: [],
      buildersWanted: false
    },
    {
      id: 'analytics',
      title: 'Analytics',
      description: 'Network monitoring and data insights',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 20V10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 20V4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 20v-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      status: 'coming-soon',
      projects: [],
      buildersWanted: false
    },
    {
      id: 'infrastructure',
      title: 'Infrastructure',
      description: 'Node operators and network services',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 21l4-7 4 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 11h.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      status: 'active',
      projects: [
        {
          id: 'inicio-labs',
          name: 'Inicio Labs',
          description: 'Private Multisig Solution',
          tags: ['Infra', 'Institutional'],
          url: 'https://multisig.miden.xyz/',
          logo: (
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 410 462" fill="none" width="32" height="32">
              <path fill="#112F48" d="m206.6 11.7q4.9 2.6 9.7 5.5 1.1 0.6 2.2 1.3c15.3 9.1 30.2 18.7 45.2 28.2 7.8 5 15.7 9.9 23.6 14.8q9.1 5.7 18.2 11.5c11.1 7 22.3 14 33.5 21q6.2 3.8 12.3 7.7 1.5 0.9 3 1.9 10.5 6.5 21 13.2 1.1 0.6 2.1 1.3 1 0.7 2 1.4c2.6 1.6 2.6 1.6 5.8 2.8 8.7 4.1 8.7 4.1 10.6 8.6 1.3 5.8 1 11.9 1 17.8q0 3.1 0.1 6.1 0.1 8.2 0.1 16.4 0 6.9 0 13.8 0.1 16.2 0.1 32.4-0.1 16.7 0.2 33.4 0.1 14.3 0.1 28.7 0 8.6 0.1 17.1c0.5 34.7 0.5 34.7-4.4 42.4-4.6 4.4-9.5 6.5-15.5 8.1-4.4 1.5-8.1 4.1-11.8 6.7q-1.3 0.8-2.7 1.7-1 0.6-2.1 1.3-8.5 5.4-17 10.7-21.1 13.2-42 26.5c-14.2 9.1-28.5 18.1-42.8 26.9q-8.6 5.3-17.2 10.7-3 1.9-6 3.8-7.6 4.7-15 9.5-1.4 0.9-2.9 1.9-2.7 1.7-5.4 3.5-1.2 0.8-2.5 1.6-1 0.7-2.1 1.4c-2.1 0.7-2.1 0.7-4.5 0.1-2.9-1.6-5.7-3.2-8.5-4.9q-0.9-0.5-1.8-1-2.7-1.7-5.4-3.4-1.9-1.1-3.8-2.3-12.8-7.8-25.4-15.8-8.1-5.2-16.4-10.3-1.5-1-3-1.9-4.7-2.9-9.3-5.8c-11.9-7.5-23.9-14.9-35.8-22.4q-9.5-6-19-12-11.6-7.2-23.2-14.6-12.1-7.7-24.2-15.3-1.6-1-3.2-2-1.4-0.9-2.9-1.8-1.3-0.8-2.6-1.6c-2.1-1.3-2.1-1.3-4.1-2.3q-0.4-40.1-0.5-80.2-0.1-18.6-0.3-37.3-0.1-16.2-0.1-32.4-0.1-8.6-0.2-17.2-0.1-8.1 0-16.2 0-3-0.1-5.9c-0.3-15-0.3-15 3.4-19.5 2.5-1.8 4.9-3.1 7.8-4.3q1.6-1 3.2-2.1c1.4-0.8 1.4-0.8 2.8-1.7q1.6-0.9 3.2-1.9c1.6-1 1.6-1 3.2-2q3.5-2.1 7-4.2 0.8-0.6 1.7-1.1 7.3-4.5 14.5-9.1 10.5-6.6 21.1-13.2 1.5-1 3-1.9 6.2-3.9 12.4-7.7 25.4-15.9 50.7-32 1.4-0.8 2.8-1.7 6.9-4.5 13.9-8.9 6.8-4.4 13.6-8.7 3-1.9 6-3.8 4.7-3 9.5-6c1.4-0.9 1.4-0.9 2.9-1.9q1.4-0.9 2.8-1.7c1.1-0.8 1.1-0.8 2.4-1.6 2.3-0.8 2.3-0.8 4.9-0.1z" />
              <path fill="white" d="m206.4 176.6c2.7 1.5 5.3 3 7.8 4.7q1.5 1 3.1 2.1 1.5 1 3.1 2.1 1.5 1 3.1 2 3.1 2.1 6.2 4.3c2.4 1.6 4.5 2.8 7.1 4 4.2 2.1 7.7 4.2 10.2 8.2 2.3 7.4 2.1 15.2 1.9 22.8-0.1 3.7 0 7.3 0.1 11 0.1 16.2 0.1 16.2-3.4 21.2-3.4 3.3-7.4 5.3-11.7 7.2-2.6 1.1-4.9 2.7-7.3 4.3q-2.3 1.4-4.7 2.9-2.3 1.5-4.7 2.9-1.1 0.7-2.2 1.4c-1.8 1.2-3.6 2.4-5.3 3.7-2.7 1.6-2.7 1.6-4.6 1.4-2.4-0.9-4.3-2-6.4-3.3q-1.3-0.8-2.6-1.6-1.3-0.9-2.7-1.7-1.2-0.8-2.5-1.6-2.7-1.7-5.4-3.5c-2.7-1.7-5.5-3-8.4-4.3-12.6-6.1-12.6-6.1-15.2-12.5-1.5-6.6-1.4-13.1-1.2-19.8 0.2-3.6 0.1-7.1 0.1-10.6 0-17.3 0-17.3 5.3-22.7 3.1-2.5 6.4-4.4 10-6.2 2.8-1.5 5.4-3.4 8-5.2q2.8-1.9 5.6-3.8 2.8-1.9 5.6-3.8 1.2-0.8 2.5-1.7c2.2-1.4 2.2-1.4 4.2-3.3 2-1.2 2-1.2 4.4-0.6z" />
            </svg>
          )
        },
        {
          id: 'miden-name',
          name: 'Miden Name',
          description: 'Name Service for Miden',
          tags: ['Name Service', 'Infra'],
          url: 'https://miden.name/',
          logo: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1366 1366" fill="none" preserveAspectRatio="xMidYMid meet" width="32" height="32">
              <g transform="translate(0, -50)">
                <path d="M1184.29,797.34v246.16c0,16.76-13.5,30.46-30.45,30.46h-146.59c-16.76,0-30.45-13.5-30.45-30.46v-161.77c0-19.97-7.96-39.45-22.25-53.59l-143.23-143.23c-9-9-24.62-2.72-24.62,10.23v348.35c0,16.76-13.5,30.46-30.45,30.46h-146.59c-16.76,0-30.45-13.5-30.45-30.46v-161.77c0-19.97-7.96-39.45-22.25-53.59l-143.23-143.23c-9-9-24.62-2.72-24.62,10.23v348.35c0,16.76-13.5,30.46-30.45,30.46h-146.59c-16.76,0-30.45-13.5-30.45-30.46V381.6c0-16.76,13.5-30.46,30.45-30.46h148.52c7.86,0,15.38,3.16,20.91,8.65l173.34,172.89c9,9,24.62,2.72,24.62-10.23v-141c0-16.76,13.5-30.46,30.45-30.46h148.52c7.86,0,15.38,3.16,20.91,8.65l381.53,381.63c15.13,15.08,23.43,35.15,23.43,56.07Z" fill="#0fe046" />
                <path d="M1184.29,381.55v225.59c0,10.23-12.36,15.38-19.53,7.96l-179.32-179.32c-5.39-5.39-8.31-12.71-8.31-20.22v-34.06c0-16.76,13.5-30.46,30.45-30.46h146.39c16.61.1,30.31,13.79,30.31,30.5Z" fill="#0fe046" />
              </g>
            </svg>
          )
        }
      ],
      buildersWanted: false
    }
  ];

  const handleToggleExpand = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  const isExpanded = (categoryId) => expandedCategory === categoryId;

  return (
    <section className="ecosystem-section">
      <div className="ecosystem-header">
        <h1 className="ecosystem-title">Miden Ecosystem</h1>
        <p className="ecosystem-subtitle">
          Discover the growing ecosystem on Miden
        </p>
      </div>

      <div className="ecosystem-container">
        <div className="ecosystem-grid">
          {ecosystemItems.map((item) => {
            const hasProjects = item.projects && item.projects.length > 0;
            const expanded = isExpanded(item.id);
            
            return (
              <div 
                key={item.id} 
                className={`ecosystem-card ${expanded ? 'expanded' : ''}`}
              >
              <div className="ecosystem-card-header">
                <div className="ecosystem-icon">
                  {item.icon}
                </div>
                  {item.status === 'coming-soon' && (
                <div className="coming-soon-badge">
                  Coming Soon
                </div>
                  )}
              </div>
              <h3 className="ecosystem-card-title">{item.title}</h3>
              <p className="ecosystem-card-description">{item.description}</p>
                
                {expanded && hasProjects && (
                  <div className="ecosystem-projects">
                    {item.projects.map((project) => (
                      <a 
                        key={project.id} 
                        href={project.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="project-mini-card"
                      >
                        <div className="project-mini-header">
                          <div className="project-mini-logo">
                            {project.logo}
                          </div>
                          <h4 className="project-mini-name">{project.name}</h4>
                        </div>
                        <p className="project-mini-description">{project.description}</p>
                        <div className="project-tags">
                          {project.tags.map((tag, idx) => (
                            <span key={idx} className="project-tag">{tag}</span>
                          ))}
                        </div>
                      </a>
                    ))}
                  </div>
                )}
                
              <div className="ecosystem-card-footer">
                  <button 
                    className="ecosystem-card-button" 
                    disabled={!hasProjects}
                    onClick={() => hasProjects && handleToggleExpand(item.id)}
                  >
                    {hasProjects ? (expanded ? 'Hide' : 'Explore') : 'Coming Soon'}
                </button>
              </div>
            </div>
            );
          })}
        </div>

        <div className="ecosystem-cta">
          <h2>Building on Miden?</h2>
          <p>Join the ecosystem and showcase your project to the community</p>
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSevoQ2T7ij7fY7Zn4a7Kfg_BmWj0pf5kfvS3nW8BsHMEGGA4Q/viewform?pli=1"
            target="_blank"
            rel="noopener noreferrer"
            className="ecosystem-submit-btn"
          >
            Submit Your Project
          </a>
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;
